// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Boolean from "../Data.Boolean/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Console from "../Effect.Console/index.js";
import * as Effect_Exception from "../Effect.Exception/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
import * as Specular_Internal_ExclusiveTask from "../Specular.Internal.ExclusiveTask/index.js";
import * as Specular_Internal_Incremental_Array from "../Specular.Internal.Incremental.Array/index.js";
import * as Specular_Internal_Incremental_Effect from "../Specular.Internal.Incremental.Effect/index.js";
import * as Specular_Internal_Incremental_Global from "../Specular.Internal.Incremental.Global/index.js";
import * as Specular_Internal_Incremental_MutableArray from "../Specular.Internal.Incremental.MutableArray/index.js";
import * as Specular_Internal_Incremental_Node from "../Specular.Internal.Incremental.Node/index.js";
import * as Specular_Internal_Incremental_Optional from "../Specular.Internal.Incremental.Optional/index.js";
import * as Specular_Internal_Incremental_PriorityQueue from "../Specular.Internal.Incremental.PriorityQueue/index.js";
import * as Specular_Internal_Incremental_Ref from "../Specular.Internal.Incremental.Ref/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
import * as Specular_Internal_Queue from "../Specular.Internal.Queue/index.js";
var $runtime_lazy = function (name, moduleName, init) {
    var state = 0;
    var val;
    return function (lineNumber) {
        if (state === 2) return val;
        if (state === 1) throw new ReferenceError(name + " was needed before it finished initializing (module " + moduleName + ", line " + lineNumber + ")", moduleName, lineNumber);
        state = 1;
        val = init();
        state = 2;
        return val;
    };
};
var showEither = /* #__PURE__ */ Data_Either.showEither(Effect_Exception.showError);
var InProgressIsSymbol = {
    reflectSymbol: function () {
        return "InProgress";
    }
};
var FinishedIsSymbol = {
    reflectSymbol: function () {
        return "Finished";
    }
};
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var max = /* #__PURE__ */ Data_Ord.max(Data_Ord.ordInt);
var $$new = /* #__PURE__ */ Specular_Internal_ExclusiveTask["new"](Effect_Class.monadEffectEffect);
var bind1 = /* #__PURE__ */ Control_Bind.bind(Effect_Aff.bindAff);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Effect_Aff.monadEffectAff);
var Var = function (x) {
    return x;
};
var Event = function (x) {
    return x;
};
var InProgress = /* #__PURE__ */ (function () {
    function InProgress(value0) {
        this.value0 = value0;
    };
    InProgress.create = function (value0) {
        return new InProgress(value0);
    };
    return InProgress;
})();
var Finished = /* #__PURE__ */ (function () {
    function Finished(value0) {
        this.value0 = value0;
    };
    Finished.create = function (value0) {
        return new Finished(value0);
    };
    return Finished;
})();
var Sync = /* #__PURE__ */ (function () {
    function Sync(value0) {
        this.value0 = value0;
    };
    Sync.create = function (value0) {
        return new Sync(value0);
    };
    return Sync;
})();
var Async = /* #__PURE__ */ (function () {
    function Async(value0) {
        this.value0 = value0;
    };
    Async.create = function (value0) {
        return new Async(value0);
    };
    return Async;
})();
var genericAsyncState_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new InProgress(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new Finished(x.value0);
        };
        throw new Error("Failed pattern match at Specular.Internal.Incremental (line 329, column 1 - line 329, column 41): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof InProgress) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof Finished) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Specular.Internal.Incremental (line 329, column 1 - line 329, column 41): " + [ x.constructor.name ]);
    }
};
var genericShow = /* #__PURE__ */ Data_Show_Generic.genericShow(genericAsyncState_);
var showAsyncState = function (dictShow) {
    var showEither1 = showEither(dictShow);
    return {
        show: genericShow(Data_Show_Generic.genericShowSum(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(Data_Maybe.showMaybe(showEither1)))(InProgressIsSymbol))(Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsArgument(showEither1))(FinishedIsSymbol)))
    };
};
var uniqBy = function (fn, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var old = Specular_Internal_Incremental_Node.get_value(node);
            var new1 = Specular_Internal_Incremental_Node.get_value(a);
            var $58 = Specular_Internal_Incremental_Optional.isSome(new1) && (!Specular_Internal_Incremental_Optional.isSome(old) || !fn(Specular_Internal_Incremental_Optional.fromSome(old), Specular_Internal_Incremental_Optional.fromSome(new1)));
            if ($58) {
                return new1;
            };
            return Specular_Internal_Incremental_Optional.none;
        },
        dependencies: pure(deps)
    });
};
var traceChanges = function (fn, input) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (_node) {
            var value_opt = Specular_Internal_Incremental_Node.get_value(input);
            var isFiring = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(input);
            (function () {
                if (isFiring) {
                    return fn(Specular_Internal_Incremental_Optional.fromSome(value_opt));
                };
                return Data_Unit.unit;
            })();
            return value_opt;
        },
        dependencies: pure([ Specular_Internal_Incremental_Node.toSomeNode(input) ])
    });
};
var sample = function (fn, signal, clock) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (_node) {
            var hasInput = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(clock);
            var result = (function () {
                if (hasInput) {
                    var signal_value = Specular_Internal_Incremental_Node.valueExc(signal);
                    var clock_value = Specular_Internal_Incremental_Node.valueExc(clock);
                    return fn(signal_value, clock_value);
                };
                return Specular_Internal_Incremental_Optional.none;
            })();
            return result;
        },
        dependencies: pure([ Specular_Internal_Incremental_Node.toSomeNode(signal), Specular_Internal_Incremental_Node.toSomeNode(clock) ])
    });
};
var readVar = function (v) {
    return v;
};
var readEvent = function (v) {
    return v;
};
var newVar = function (val) {
    var node = Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var value = Specular_Internal_Incremental_Node.valueExc(node);
            return Specular_Internal_Incremental_Optional.some(value);
        },
        dependencies: pure([  ])
    });
    Specular_Internal_Incremental_Node.set_value(node, Specular_Internal_Incremental_Optional.some(val));
    return node;
};
var newEvent = function __do() {
    var node = Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            return Specular_Internal_Incremental_Node.get_value(node);
        },
        dependencies: pure([  ])
    });
    return node;
};
var mapOptional = function (fn, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var value_a = Specular_Internal_Incremental_Node.get_value(a);
            var $63 = Specular_Internal_Incremental_Optional.isSome(value_a);
            if ($63) {
                return fn(Specular_Internal_Incremental_Optional.fromSome(value_a));
            };
            return Specular_Internal_Incremental_Optional.none;
        },
        dependencies: pure(deps)
    });
};
var mapN = function (fn, inputs) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var values = Specular_Internal_Incremental_Array.mapE(inputs, Specular_Internal_Incremental_Node.valueExc);
            return Specular_Internal_Incremental_Optional.some(fn(values));
        },
        dependencies: pure(Specular_Internal_Incremental_Node.toSomeNodeArray(inputs))
    });
};
var map2 = function (fn, a, b) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a), Specular_Internal_Incremental_Node.toSomeNode(b) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var value_a = Specular_Internal_Incremental_Node.valueExc(a);
            var value_b = Specular_Internal_Incremental_Node.valueExc(b);
            return Specular_Internal_Incremental_Optional.some(fn(value_a, value_b));
        },
        dependencies: pure(deps)
    });
};
var map = function (fn, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var value_a = Specular_Internal_Incremental_Node.valueExc(a);
            return Specular_Internal_Incremental_Optional.some(fn(value_a));
        },
        dependencies: pure(deps)
    });
};
var leftmost = function (inputs) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (_node) {
            return Specular_Internal_Incremental_Effect.foreachUntil(inputs, function (input) {
                var isFiring = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(input);
                if (isFiring) {
                    return Specular_Internal_Incremental_Node.get_value(input);
                };
                return Specular_Internal_Incremental_Optional.none;
            });
        },
        dependencies: pure(Specular_Internal_Incremental_Node.toSomeNodeArray(inputs))
    });
};
var isTracing = false;
var trace = /* #__PURE__ */ (function () {
    if (isTracing) {
        return Effect_Console.log;
    };
    return function (v) {
        return pure(Data_Unit.unit);
    };
})();
var globalRecomputeQueue = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_PriorityQueue["new"](Specular_Internal_Incremental_Optional.none, "height", "inRecomputeQueue", "nextInRecomputeQueue");
});
var triggerEvent = function (v, val) {
    Specular_Internal_Incremental_Node.set_value(v, Specular_Internal_Incremental_Optional.some(val));
    Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, Specular_Internal_Incremental_Node.toSomeNode(v));
    return Data_Unit.unit;
};
var globalEffectQueue = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(Specular_Internal_Queue["new"]);
var fold = function (fn, initial, a) {
    var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
    return Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var state_opt = Specular_Internal_Incremental_Node.get_value(node);
            var state = (function () {
                var $67 = Specular_Internal_Incremental_Optional.isSome(state_opt);
                if ($67) {
                    return Specular_Internal_Incremental_Optional.fromSome(state_opt);
                };
                return initial;
            })();
            var hasInput = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(a);
            var result = (function () {
                if (hasInput) {
                    var input = Specular_Internal_Incremental_Node.valueExc(a);
                    return fn(input, state);
                };
                return Specular_Internal_Incremental_Optional.some(state);
            })();
            return result;
        },
        dependencies: pure(deps)
    });
};
var ensureHeight = function (node, newHeight) {
    var oldAdjustedHeight = Specular_Internal_Incremental_Node.get_adjustedHeight(node);
    return Specular_Internal_Incremental_Node.set_adjustedHeight(node, max(oldAdjustedHeight)(newHeight));
};
var recomputeNode = function (node) {
    var height = Specular_Internal_Incremental_Node.get_height(node);
    var adjustedHeight = Specular_Internal_Incremental_Node.get_adjustedHeight(node);
    var $69 = adjustedHeight > height;
    if ($69) {
        var mark = Specular_Internal_Profiling.begin("bump height " + Specular_Internal_Incremental_Node.name(node));
        var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
        Specular_Internal_Incremental_MutableArray.iterate(dependents, function (dependent) {
            return ensureHeight(dependent, adjustedHeight + 1 | 0);
        });
        Specular_Internal_Incremental_Node.set_height(node, adjustedHeight);
        Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, node);
        return Specular_Internal_Profiling.end(mark);
    };
    var mark = Specular_Internal_Profiling.begin("compute " + Specular_Internal_Incremental_Node.name(node));
    var source = Specular_Internal_Incremental_Node.get_source(node);
    var newValue_opt = source.compute(node);
    (function () {
        var $70 = Specular_Internal_Incremental_Optional.isSome(newValue_opt);
        if ($70) {
            var newValue = Specular_Internal_Incremental_Optional.fromSome(newValue_opt);
            Specular_Internal_Incremental_Node.set_value(node, Specular_Internal_Incremental_Optional.some(newValue));
            var currentStabilizationNum = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum);
            Specular_Internal_Incremental_Node.set_changedAt(node, currentStabilizationNum);
            var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
            Specular_Internal_Incremental_MutableArray.iterate(dependents, function (dependent) {
                var _added = Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, dependent);
                return Data_Unit.unit;
            });
            var observers = Specular_Internal_Incremental_Node.get_observers(node);
            return Specular_Internal_Incremental_MutableArray.iterate(observers, function (observer) {
                return observer(newValue);
            });
        };
        return Data_Unit.unit;
    })();
    return Specular_Internal_Profiling.end(mark);
};
var stabilize = function __do() {
    var mark = Specular_Internal_Profiling.begin("stabilize");
    var stabilizationNum = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum);
    (function () {
        var $71 = stabilizationNum !== Specular_Internal_Incremental_Global.stabilizationIsNotInProgress;
        if ($71) {
            return Partial_Unsafe.unsafeCrashWith("Specular: stabilize called when stabilization already in progress")();
        };
        return Data_Unit.unit;
    })();
    var oldStabilizationNum = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalLastStabilizationNum);
    var currentStabilizationNum = oldStabilizationNum + 1 | 0;
    Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalLastStabilizationNum, currentStabilizationNum);
    Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum, currentStabilizationNum);
    Specular_Internal_Incremental_PriorityQueue.drain(globalRecomputeQueue, recomputeNode);
    Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalCurrentStabilizationNum, Specular_Internal_Incremental_Global.stabilizationIsNotInProgress);
    Specular_Internal_Profiling.end(mark);
    var mark2 = Specular_Internal_Profiling.begin("drainEffects");
    Specular_Internal_Queue.drain(globalEffectQueue, function (handler) {
        return handler();
    });
    return Specular_Internal_Profiling.end(mark2);
};
var effectCrash = function (msg) {
    return function (v) {
        return Partial_Unsafe.unsafeCrashWith(msg);
    };
};
var constant = function (value) {
    return Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            return Specular_Internal_Incremental_Optional.some(value);
        },
        dependencies: pure([  ])
    });
};
var addToRecomputeQueue = function (node) {
    Specular_Internal_Incremental_PriorityQueue.add(globalRecomputeQueue, Specular_Internal_Incremental_Node.toSomeNode(node));
    return Data_Unit.unit;
};
var mapAsync = /* #__PURE__ */ (function () {
    var getPreviousValue = function (opt) {
        if (Specular_Internal_Incremental_Optional.isSome(opt)) {
            var v = Specular_Internal_Incremental_Optional.fromSome(opt);
            if (v instanceof InProgress) {
                return v.value0;
            };
            if (v instanceof Finished) {
                return new Data_Maybe.Just(v.value0);
            };
            throw new Error("Failed pattern match at Specular.Internal.Incremental (line 372, column 7 - line 374, column 29): " + [ v.constructor.name ]);
        };
        if (Data_Boolean.otherwise) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Specular.Internal.Incremental (line 370, column 3 - line 375, column 26): " + [ opt.constructor.name ]);
    };
    return function (fn, a) {
        var deps = [ Specular_Internal_Incremental_Node.toSomeNode(a) ];
        var task = $$new();
        var finishedRef = Specular_Internal_Incremental_Ref["new"](Data_Maybe.Nothing.value);
        return Specular_Internal_Incremental_Node.create({
            compute: function (self) {
                var finished = Specular_Internal_Incremental_Ref.read(finishedRef);
                if (finished instanceof Data_Maybe.Nothing) {
                    var value_a = Specular_Internal_Incremental_Node.valueExc(a);
                    var v = fn(value_a);
                    if (v instanceof Sync) {
                        return Specular_Internal_Incremental_Optional.some(new Finished(new Data_Either.Right(v.value0)));
                    };
                    if (v instanceof Async) {
                        Specular_Internal_Effect.nextMicrotask(Specular_Internal_ExclusiveTask.run(task)(bind1(v.value0)(function (newValue) {
                            return liftEffect(function __do() {
                                Specular_Internal_Incremental_Ref.write(finishedRef, new Data_Maybe.Just(new Data_Either.Right(newValue)));
                                addToRecomputeQueue(self);
                                return stabilize();
                            });
                        })))();
                        var previous = Specular_Internal_Incremental_Node.get_value(self);
                        return Specular_Internal_Incremental_Optional.some(new InProgress(getPreviousValue(previous)));
                    };
                    throw new Error("Failed pattern match at Specular.Internal.Incremental (line 345, column 13 - line 357, column 78): " + [ v.constructor.name ]);
                };
                if (finished instanceof Data_Maybe.Just) {
                    Specular_Internal_Incremental_Ref.write(finishedRef, Data_Maybe.Nothing.value);
                    return Specular_Internal_Incremental_Optional.some(new Finished(finished.value0));
                };
                throw new Error("Failed pattern match at Specular.Internal.Incremental (line 342, column 9 - line 365, column 46): " + [ finished.constructor.name ]);
            },
            dependencies: pure(deps)
        });
    };
})();
var setVar = function (v, val) {
    Specular_Internal_Incremental_Node.set_value(v, Specular_Internal_Incremental_Optional.some(val));
    return addToRecomputeQueue(v);
};
var $lazy_addDependent = /* #__PURE__ */ $runtime_lazy("addDependent", "Specular.Internal.Incremental", function () {
    return function (node, dependent) {
        var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
        var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
        Specular_Internal_Incremental_MutableArray.push(dependents, dependent);
        return $lazy_handleRefcountChange(119)(node, oldRefcount);
    };
});
var $lazy_connect = /* #__PURE__ */ $runtime_lazy("connect", "Specular.Internal.Incremental", function () {
    return function (node) {
        var mark = Specular_Internal_Profiling.begin("connect " + Specular_Internal_Incremental_Node.name(node));
        var source = Specular_Internal_Incremental_Node.get_source(node);
        var dependencies = source.dependencies();
        Specular_Internal_Incremental_Array.iterate(dependencies, function (dependency) {
            $lazy_addDependent(158)(dependency, Specular_Internal_Incremental_Node.toSomeNode(node));
            var dependencyHeight = Specular_Internal_Incremental_Node.get_height(dependency);
            var adjustedHeight = Specular_Internal_Incremental_Node.get_adjustedHeight(node);
            var ourHeight = Specular_Internal_Incremental_Node.get_height(node);
            var desiredHeight = max(dependencyHeight + 1 | 0)(adjustedHeight);
            var $82 = desiredHeight > ourHeight;
            if ($82) {
                Specular_Internal_Incremental_Node.set_height(node, desiredHeight);
                return Specular_Internal_Incremental_Node.set_adjustedHeight(node, desiredHeight);
            };
            return Data_Unit.unit;
        });
        var value = source.compute(node);
        (function () {
            var $83 = Specular_Internal_Incremental_Optional.isSome(value);
            if ($83) {
                return Specular_Internal_Incremental_Node.set_value(node, value);
            };
            return Data_Unit.unit;
        })();
        return Specular_Internal_Profiling.end(mark);
    };
});
var $lazy_disconnect = /* #__PURE__ */ $runtime_lazy("disconnect", "Specular.Internal.Incremental", function () {
    return function (node) {
        var mark = Specular_Internal_Profiling.begin("disconnect " + Specular_Internal_Incremental_Node.name(node));
        var source = Specular_Internal_Incremental_Node.get_source(node);
        var dependencies = source.dependencies();
        Specular_Internal_Incremental_Array.iterate(dependencies, function (dependency) {
            return $lazy_removeDependent(190)(dependency, Specular_Internal_Incremental_Node.toSomeNode(node));
        });
        return Specular_Internal_Profiling.end(mark);
    };
});
var $lazy_handleRefcountChange = /* #__PURE__ */ $runtime_lazy("handleRefcountChange", "Specular.Internal.Incremental", function () {
    return function (node, oldRefcount) {
        var newcount = Specular_Internal_Incremental_Node.refcount(node);
        (function () {
            var $84 = oldRefcount === 0 && newcount > 0;
            if ($84) {
                return $lazy_connect(132)(node);
            };
            var $85 = oldRefcount > 0 && newcount === 0;
            if ($85) {
                return $lazy_disconnect(134)(node);
            };
            return Data_Unit.unit;
        })();
        var oldTotalRefcount = Specular_Internal_Incremental_Ref.read(Specular_Internal_Incremental_Global.globalTotalRefcount);
        return Specular_Internal_Incremental_Ref.write(Specular_Internal_Incremental_Global.globalTotalRefcount, (oldTotalRefcount - oldRefcount | 0) + newcount | 0);
    };
});
var $lazy_removeDependent = /* #__PURE__ */ $runtime_lazy("removeDependent", "Specular.Internal.Incremental", function () {
    return function (node, dependent) {
        var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
        var dependents = Specular_Internal_Incremental_Node.get_dependents(node);
        Specular_Internal_Incremental_MutableArray.remove(dependents, dependent);
        return $lazy_handleRefcountChange(126)(node, oldRefcount);
    };
});
var addDependent = /* #__PURE__ */ $lazy_addDependent(112);
var connect = /* #__PURE__ */ $lazy_connect(150);
var disconnect = /* #__PURE__ */ $lazy_disconnect(182);
var handleRefcountChange = /* #__PURE__ */ $lazy_handleRefcountChange(128);
var removeDependent = /* #__PURE__ */ $lazy_removeDependent(121);
var addObserver = function (node, observer) {
    var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
    var observers = Specular_Internal_Incremental_Node.get_observers(node);
    Specular_Internal_Incremental_MutableArray.push(observers, observer);
    return handleRefcountChange(node, oldRefcount);
};
var removeObserver = function (node, observer) {
    var oldRefcount = Specular_Internal_Incremental_Node.refcount(node);
    var observers = Specular_Internal_Incremental_Node.get_observers(node);
    Specular_Internal_Incremental_MutableArray.remove(observers, observer);
    return handleRefcountChange(node, oldRefcount);
};
var subscribeNode = function (handler, node) {
    var h = function (value) {
        return Specular_Internal_Queue.enqueue(globalEffectQueue, handler(value));
    };
    addObserver(node, h);
    return function () {
        return removeObserver(node, h);
    };
};
var $$switch = function (alwaysFire, lhs, fn) {
    var main_node_ref = Specular_Internal_Incremental_Ref["new"](Specular_Internal_Incremental_Optional.none);
    var rhs_node = Specular_Internal_Incremental_Node.create({
        compute: function (node) {
            var value_lhs = Specular_Internal_Incremental_Node.valueExc(lhs);
            var rhs = fn(value_lhs);
            var main_opt = Specular_Internal_Incremental_Ref.read(main_node_ref);
            var main = Specular_Internal_Incremental_Optional.fromSome(main_opt);
            addDependent(rhs, Specular_Internal_Incremental_Node.toSomeNode(main));
            var dependencyHeight = Specular_Internal_Incremental_Node.get_height(rhs);
            ensureHeight(main, dependencyHeight + 1 | 0);
            var old_rhs_opt = Specular_Internal_Incremental_Node.get_value(node);
            (function () {
                var $86 = Specular_Internal_Incremental_Optional.isSome(old_rhs_opt);
                if ($86) {
                    return removeDependent(Specular_Internal_Incremental_Optional.fromSome(old_rhs_opt), Specular_Internal_Incremental_Node.toSomeNode(main));
                };
                return Data_Unit.unit;
            })();
            return Specular_Internal_Incremental_Optional.some(rhs);
        },
        dependencies: pure([ Specular_Internal_Incremental_Node.toSomeNode(lhs) ])
    });
    Specular_Internal_Incremental_Node.annotate(rhs_node, "switch data");
    var main = Specular_Internal_Incremental_Node.create({
        compute: function (v) {
            var rhs = Specular_Internal_Incremental_Node.valueExc(rhs_node);
            var isFiring = Specular_Internal_Incremental_Node.isChangingInCurrentStabilization(rhs);
            var $87 = alwaysFire || isFiring;
            if ($87) {
                return Specular_Internal_Incremental_Node.get_value(rhs);
            };
            return Specular_Internal_Incremental_Optional.none;
        },
        dependencies: function __do() {
            var rhs_opt = Specular_Internal_Incremental_Node.get_value(rhs_node);
            var $88 = Specular_Internal_Incremental_Optional.isSome(rhs_opt);
            if ($88) {
                return [ Specular_Internal_Incremental_Node.toSomeNode(rhs_node), Specular_Internal_Incremental_Node.toSomeNode(Specular_Internal_Incremental_Optional.fromSome(rhs_opt)) ];
            };
            return [ Specular_Internal_Incremental_Node.toSomeNode(rhs_node) ];
        }
    });
    Specular_Internal_Incremental_Ref.write(main_node_ref, Specular_Internal_Incremental_Optional.some(main));
    return main;
};
var bind_ = function (lhs, fn) {
    return $$switch(true, lhs, fn);
};
export {
    globalRecomputeQueue,
    Var,
    newVar,
    setVar,
    addToRecomputeQueue,
    readVar,
    Event,
    newEvent,
    triggerEvent,
    readEvent,
    addObserver,
    removeObserver,
    addDependent,
    removeDependent,
    handleRefcountChange,
    connect,
    disconnect,
    globalEffectQueue,
    subscribeNode,
    stabilize,
    recomputeNode,
    constant,
    map,
    mapOptional,
    Sync,
    Async,
    InProgress,
    Finished,
    mapAsync,
    map2,
    mapN,
    bind_,
    $$switch as switch,
    fold,
    uniqBy,
    sample,
    leftmost,
    traceChanges,
    ensureHeight,
    effectCrash,
    isTracing,
    trace,
    genericAsyncState_,
    showAsyncState
};
